import { render, staticRenderFns } from "./ShippingItemsModal.vue?vue&type=template&id=546e2ac9&scoped=true&"
import script from "./ShippingItemsModal.vue?vue&type=script&lang=js&"
export * from "./ShippingItemsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546e2ac9",
  null
  
)

export default component.exports